import React from 'react';
import { Grid, Typography, Divider } from '@mui/material';
import { FormikProps } from 'formik';
import CompanySearch from '../CompanySearch';
import { CompanyResult } from '../../../types/company.types';
import { BusinessType } from '../../../types/client';

// Define a simplified FormValues interface just for this component
interface FormValues {
  companyName: string;
  businessType: BusinessType;
  [key: string]: any; // Allow other fields that might be accessed
}

interface Props {
  formik: FormikProps<FormValues>;
  onCompanySelect: (company: CompanyResult | null) => void;
  companySearchError?: string;
  disabled?: boolean;
  selectedCompany: CompanyResult | null;
}

const CompaniesHouseSection: React.FC<Props> = ({ 
  formik, 
  onCompanySelect, 
  companySearchError,
  disabled = false,
  selectedCompany
}) => (
  <>
    <Grid item xs={12}>
      <Typography variant="h6" gutterBottom>Registry Search</Typography>
      <Typography variant="caption" color="text.secondary" gutterBottom>
        Search Companies House or OSCR to automatically populate business details
      </Typography>
      <Divider sx={{ mb: 2 }} />
    </Grid>
    
    <Grid item xs={12}>
      <CompanySearch
        onCompanySelect={onCompanySelect}
        error={companySearchError}
        disabled={disabled}
        value={selectedCompany}
        initialInputValue={formik.values.companyName}
      />
    </Grid>
  </>
);

export default CompaniesHouseSection;
